"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputRaw = _interopRequireDefault(require("../InputRaw"));
var _InputContainer = _interopRequireDefault(require("@commerce-ui/core2/InputContainer"));
var _excluded = ["onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var isValueEmpty = function isValueEmpty(val) {
  return val === undefined || val === null || val.toString() === "";
};
var Input$ = function Input$(props) {
  var onChange = props.onChange,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(props.value),
    value = _useState[0],
    setValue = _useState[1];
  var isEmpty = isValueEmpty(value);
  var onChangeEvent = function onChangeEvent(val, e) {
    setValue(val);
    if (onChange) {
      onChange(val, e);
    }
  };
  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: isEmpty,
    onClear: function onClear() {
      onChangeEvent("", null);
    },
    label: props.label || props.placeholder,
    cursor: "text"
  }), __jsx(_InputRaw["default"], {
    sx: {
      width: "100%",
      height: "100%"
    },
    onChange: onChangeEvent,
    value: value
  }));
};
var _default = Input$;
exports["default"] = _default;